<template>
  <el-card class="box-card main-card">
    <el-button v-if="$route.query.userId" size="mini" class="pxy-primary return-button" style="margin-right: 10px;" @click="$router.go(-1)">返回</el-button>
    <el-tabs v-model="activeTab">
      <el-tab-pane label="全部" name="all">

        <el-form class="search-form" ref="form" :model="searchForm">
          <el-form-item v-if="$route.query.userId" label="用户名称：" label-width="85px">
            <el-tag effect="plain">{{$route.query.userName}}</el-tag>
          </el-form-item>
          <el-form-item label="创建时间：" label-width="85px">
            <el-select v-model="searchForm.orderPeriod"
                       @change="searchFn"
                      placeholder="" style="width:120px">
              <el-option
                v-for="(item,index) in orderPeriods"
                :key="index"
                :label="item.label"
                :value="index">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" label-width="20px">
            <el-input v-model="searchForm.orderId" placeholder="请输入订单号" >
              <el-button slot="append" @click="searchFn" icon="el-icon-search"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="状态：" label-width="85px">

            <el-select v-model="searchForm.status" placeholder="请选择状态"  @change="statusChangeFn" size="small">
              <el-option v-for="item in statusOptions"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <template>
          <el-table
            :data="tableData"
            style="width: 100%"
            row-key="orderId"
            border>
            <el-table-column type="expand">
              <template slot-scope="props">
          <!--      <span>{{props.rows.pocOrderDetails}}</span>-->
                  <el-table
                    :data="props.row.pocOrderDetailList"
                    style="width: 100%"
                    border
                    height="250">
                    <el-table-column
                      fixed
                      label="名称">
                      <template  slot-scope="scope">
                        {{scope.row.itemName }}
                        <span v-if="scope.row.itemId=='933025054038425600' ||  scope.row.itemId=='933026101272248320'">
                          <router-link :to="{ path: '/sdkLicence/index',query:{ orderId:scope.row.orderId}}">去查看</router-link>
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="单价">
                      <template  slot-scope="scope">
                        {{scope.row.price }}&nbsp;{{scope.row.priceUnit }}
                      </template>
                    </el-table-column>

                    <el-table-column
                      label="数量">
                      <template  slot-scope="scope" >
                        <span v-if="scope.row.cnt != null">{{scope.row.cnt }}&nbsp;{{scope.row.cntUnit }}</span>
                        <span v-else>--</span>

                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="amount"
                      label="总金额">
                    </el-table-column>
                    <el-table-column
                      prop="consumePeriod"
                      label="消费期间">
                    </el-table-column>
                    <el-table-column
                      prop="startDate"
                      label="开始时间">
                      <template  slot-scope="scope">
                        {{scope.row.startDate | formatDate}}
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
            </el-table-column>
            <el-table-column label="产品信息" width="350px">
              <template slot-scope="scope">
                <div class="vertical-middle" >
                  <div class="vertical-middle">
                    <i v-if="scope.row.orderType=='1'" style="padding: 15px;border: 1px solid #e5e5e5;font-size: 20px;"
                       class="el-icon-coordinate"></i>
                    <i v-if="scope.row.orderType=='3'" style="padding: 15px;border: 1px solid #e5e5e5;font-size: 20px;"
                       class="el-icon-goods"></i>
                    <i v-if="scope.row.orderType=='5'" style="padding: 15px;border: 1px solid #e5e5e5;font-size: 20px;"
                                                               class="el-icon-picture-outline"></i>
                    <i v-if="scope.row.orderType=='2'" style="padding: 15px;border: 1px solid #e5e5e5;font-size: 20px;"
                       class="el-icon-s-shop"></i>
                    <i v-if="scope.row.orderType=='6'" style="padding: 15px;border: 1px solid #e5e5e5;font-size: 20px;"
                       class="el-icon-connection"></i>
                  </div>
                  <div class="vertical-middle" style="margin-left: 10px;width: auto">
                    <div v-if="scope.row.orderType=='1'">云授权</div>
                    <div v-else-if="scope.row.orderType=='3'">托管应用</div>
                    <div v-else-if="scope.row.orderType=='5'">定制Logo</div>
                    <div v-else-if="scope.row.orderType=='6'">代理转发</div>
                    <div v-else-if="scope.row.orderType=='2'">SDK授权</div>
                    <div class="vertical-middle" style="font-size: 12px;color: #999;">{{scope.row.chargeType | formatChargeType}}
                    </div>
                    <el-divider direction="vertical"></el-divider>
                    <div class="vertical-middle">
                      <span style="font-size: 12px;color: #999">{{scope.row.startDate | formatDate}}</span>-
                      <span style="font-size: 12px;color: #999" v-if="scope.row.endDate == null">永久</span>
                      <span style="font-size: 12px;color: #999" v-else>{{scope.row.endDate | formatDate}}</span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="订单号">

              <template slot-scope="scope">
                <span> {{scope.row.orderId}}</span>
              </template>
            </el-table-column>
            <el-table-column label="资源ID">

              <template slot-scope="scope">
                <span> {{scope.row.resourceId}}</span>
              </template>
            </el-table-column>
            <el-table-column label="资源实例">

              <template slot-scope="scope">
                <span> {{scope.row.resourceName}}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="订单状态">
              <template slot-scope="scope">
                <span>
                  <i v-if="scope.row.status == 'Y'" class="el-icon-success success"
                     style="color: #67C23A"></i>
                        <i v-else class="el-icon-warning warning" style="color:#E6A23C"></i>
                  {{scope.row.status | formatOrderStatus}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="订单金额" prop="orderPrice">
            </el-table-column>
            <el-table-column label="创建时间">

              <template slot-scope="scope">
                <span> {{scope.row.createDate | formatDateTime}}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <PageComponent ref="pageInfo"></PageComponent>
      </el-tab-pane>
      <!--      <el-tab-pane label="汇总" name="second">汇总</el-tab-pane> -->
    </el-tabs>

  </el-card>

</template>

<script>
  import PageComponent from '@/components/pageInfo/PageComponent'
  import {Message} from "element-ui";
  import $ from 'jquery'

  export default {
    components: {PageComponent},
    data() {
      return {
        activeTab: 'all',
        searchForm: {
          orderPeriod: 0,
          orderId: '',
          status: 1
        },
        // 状态下拉列表
        statusOptions: [
          {value: '', label: '全部'},
          {value: 1, label: '有效'},
          {value: 0, label: '停用'},
        ],
        orderPeriods: [],
        tableData: []
      }
    },
    beforeCreate() {

    },
    created() {
      this.getSearchPeriod()
    },
    methods: {
      getSearchPeriod() {
        //创建现在的时间
        let date = new Date();
        //获取年
        let year = date.getFullYear();
        //获取月
        let mon = date.getMonth() + 1;
        var period1 = {}, period2 = {}, period3 = {}, period4 = {}, period5 = {};
        //近6个月
        period1.label = "近6个月";
        period1.beginDate = this.getDate(year, mon, 6);
        if(mon == 12){
          period1.overDate = new Date(parseInt(year + 1) + "/" + mon + '/01').getTime();
        }else {
          period1.overDate = new Date(year + "/" + parseInt(mon + 1) + '/01').getTime();
        }
        this.orderPeriods.push(period1)
        //近一年
        period2.label = "近一年";
        period2.beginDate = this.getDate(year, mon, 12);
        if(mon == 12){
          period2.overDate = new Date(parseInt(year + 1) + "/" + mon + '/01').getTime();
        }else{
          period2.overDate = new Date(year + "/" + parseInt(mon + 1) + '/01').getTime();
        }

        this.orderPeriods.push(period2)
        //去年
        period3.label = parseInt(year - 1);
        period3.beginDate = new Date(parseInt(year - 1) + "/01" + '/01').getTime();
        period3.overDate = new Date(year + "/01" + '/01').getTime();
        this.orderPeriods.push(period3)
        //前年
        period4.label = parseInt(year - 2);
        period4.beginDate = new Date(parseInt(year - 2) + "/01" + '/01').getTime();
        period4.overDate = new Date(parseInt(year - 1) + "/01" + '/01').getTime();
        this.orderPeriods.push(period4)
        //大前年
        period5.label = parseInt(year - 3);
        period5.beginDate = new Date(parseInt(year - 3) + "/01" + '/01').getTime();
        period5.overDate = new Date(parseInt(year - 2) + "/01" + '/01').getTime();
        this.orderPeriods.push(period5)
        this.searchForm.orderPeriod = 0;
        console.log(this.searchForm.orderPeriod)
      },
      getDate(year, month, minus) {
        month = month - minus;
        if (month <= 0) {
          year = year - 1;
          month = month + 12;
        }
        if (month < 10) {
          month = "0" + month;
        }

        return new Date(year + "/" + month + '/01').getTime();
      },
      getOrders: function () {
        var params = {};
        if(this.$route.query.userId){
          params.userId = this.$route.query.userId;
        }

        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = 10;
        params.startTime = this.orderPeriods[this.searchForm.orderPeriod].beginDate;
        params.endTime = this.orderPeriods[this.searchForm.orderPeriod].overDate;
        if (this.searchForm.orderId != null) {
          params.orderId = this.searchForm.orderId
        }
        if (this.searchForm.status != null && this.searchForm.status !== '') {
          params.status = this.searchForm.status
        }
        this.getRequest('/pocOrder/list', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.tableData = resp.data.result.records;
              console.log(this.tableData)
              this.$refs.pageInfo.outputPagenator(resp.data.result.total, resp.data.result.pageSize);
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      setColSpan: function () {
        var x = document.getElementsByClassName("el-table__header")[0].rows[1].cells;
        // 将第二列表头单元格的colSpan设为4
        x[1].colSpan = 4
        // 将第三列表头单元格的display设为none
        x[2].style.display = 'none'
        x[3].style.display = 'none'
        x[4].style.display = 'none'
      },
      // 搜索条件改变时
      searchFn() {
        var queryStr = JSON.parse(JSON.stringify(this.$route.query));
        queryStr.page = 1;
        this.$router.push({query: queryStr});
        this.getOrders();
      },
      // 订单查询 - （用户管理菜单页跳转过来）
      getUserIdOrder() {
        let params = {
          userId: this.$route.query.userId,
          page: this.$refs.pageInfo.currentPage,
          pageSize: 10
        }
        params.startTime = this.orderPeriods[this.searchForm.orderPeriod].beginDate;
        params.endTime = this.orderPeriods[this.searchForm.orderPeriod].overDate;
        if (this.searchForm.orderId != null) {
          params.orderId = this.searchForm.orderId
        }
        if (this.searchForm.status != null && this.searchForm.status !== '') {
          params.status = this.searchForm.status
        }
        this.getRequest('/pocOrder/list', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.tableData = resp.data.result.records;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total, resp.data.result.pageSize);
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },

      // 查询状态change
      statusChangeFn(val) {
        console.log(val);
        this.searchForm.status = val;
        let queryStr = JSON.parse(JSON.stringify(this.$route.query));
        queryStr.page = 1;
        this.$router.push({query: queryStr});
        this.getOrders();
      },
    },
    mounted: function () {
      if(this.$route.query.userId){ // 订单查询 - （用户管理菜单页跳转过来）
        this.$refs.pageInfo.initPagenator(this.getUserIdOrder, null);
        this.getUserIdOrder();
      } else {
        this.getOrders();
        this.$refs.pageInfo.initPagenator(this.getOrders, null);
      }
    },
    watch: {
      'tableData': function () {
        this.$nextTick(function () {
            //this.setColSpan();
          }
        )
      }
    },
    beforeDestroy() {

    }
  }
</script>

